module.exports = __webpack_public_path__ + "media/img/android-icon-48x48-a36b6ca028a149dc8f58585b1e7fac63.png";